
import { downloadMixin } from '../../mixins'
import EoCarouselItem from './EoCarouselItem.vue'
import EoButton from '../EoButton/EoButton.vue'
import EoIcon from '../EoIcon/EoIcon.vue'
import EoSpinner from '../EoSpinner/EoSpinner.vue'
import EoTransitionAccordion from '../EoTransitionAccordion/EoTransitionAccordion.vue'

export default {
  name: 'EoCarousel',
  components: {
    EoCarouselItem,
    EoButton,
    EoIcon,
    EoSpinner,
    EoTransitionAccordion,
  },
  mixins: [
    downloadMixin,
  ],
  props: {
    /**
     * Array with media files for carousel to show
     */
    media: {
      type: Array,
      default: null,
    },
    /**
     * Enables image contain mode for images with different aspect ratio
     */
    respectRatio: Boolean,
    /**
     * Show carousel in portrait mode
     */
    portrait: Boolean,
    /**
     * Set the transition animation (slide, fade)
     */
    transition: {
      type: String,
      validator: value => Object.values(['slide', 'fade']).includes(value),
      default: 'slide',
    },
    /**
     * Adds possibility to make drag movement to go to other slide
     */
    hasDrag: {
      type: Boolean,
      default: true,
    },
    /**
     * Make the carousel scroll infinitely
     */
    repeat: {
      type: Boolean,
      default: true,
    },
    /**
     * Show indicators for slides
     */
    indicators: {
      type: Boolean,
      default: true,
    },
    /**
     * Set functions of indicators, For example click or hover
     */
    indicatorMode: {
      type: String,
      default: 'click',
    },
    /**
     * Accent color in the carousel
     */
    color: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      activeIndex: 0,
      carouselItems: [],
      dragXStart: 0,
      dragXCurrent: 0,
      dragXEl: null,
    }
  },
  computed: {
    activeItem () {
      return this.carouselItems[this.activeIndex]
    },
    hasSingleItem () {
      return this.carouselItems.length === 1
    },
  },
  mounted () {
    if (this.activeIndex < this.carouselItems.length) {
      this.carouselItems[this.activeIndex].isActive = true
    }
  },
  methods: {
    /**
     * Change the active item and emit change event.
     * action only for animated slide, there true = next, false = prev
     */
    changeItem (newIndex, action = true) {
      if (this.activeIndex === newIndex) return
      if (this.activeIndex < this.carouselItems.length) {
        this.carouselItems[this.activeIndex].status(false, action)
      }
      this.carouselItems[newIndex].status(true, action)
      this.activeIndex = newIndex
      this.$emit('change', newIndex)
    },
    /**
     * Indicator trigger when change active item.
     */
    modeChange (trigger, value) {
      if (this.indicatorMode === trigger) {
        this.$emit('input', value)
        return value < this.activeIndex
          ? this.changeItem(value)
          : this.changeItem(value, false)
      }
    },
    prev () {
      if (this.activeIndex === 0) {
        if (this.repeat) this.changeItem(this.carouselItems.length - 1)
      } else {
        this.changeItem(this.activeIndex - 1)
      }
    },
    next () {
      if (this.activeIndex === this.carouselItems.length - 1) {
        if (this.repeat) this.changeItem(0, false)
      } else {
        this.changeItem(this.activeIndex + 1, false)
      }
    },
    dragStart (event) {
      if (!this.hasDrag) return
      this.dragXStart = event.touches ? event.changedTouches[0].pageX : event.pageX
      this.dragXEl = event.toElement
      if (!event.touches) {
        event.preventDefault()
      }
    },
    dragMove (event) {
      if (!this.hasDrag || this.dragXStart == 0) return
      const detected = event.touches ? event.changedTouches[0].pageX : event.pageX
      this.dragXCurrent = detected - this.dragXStart
      if (Math.abs(this.dragXCurrent) > 10) {
        // we are dragging horizontally, prevent page scroll
        event.preventDefault()
      }
    },
    dragEnd (event) {
      if (!this.hasDrag || this.dragXStart == 0) return
      if (this.dragXEl == event.toElement) {
        const detected = event.touches ? event.changedTouches[0].pageX : event.pageX
        const diffX = detected - this.dragXStart
        if (Math.abs(diffX) > 50) {
          if (diffX < 0) {
            this.next()
          } else {
            this.prev()
          }
        }
      }
      this.resetDragX()
    },
    resetDragX () {
      this.dragXStart = 0
      this.dragXCurrent = 0
      this.dragXEl = null
    },
  },
}
